import './index.css'

import { StrictMode } from 'react'
import ReactDOM from 'react-dom'
import './i18n'
import { App } from './modules/App'
import reportWebVitals from './reportWebVitals'
import { startup } from './startup'

startup()

ReactDOM.render(
  <StrictMode>
    <App />
  </StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
